import VerifyInvitation from "./verify-invitation.container";

export default VerifyInvitation;
